export default __webpack_public_path__ + "static/media/logo-pride-diagonal.c9e6c413.png";